export default "/listings/img/pro-pin.png";